<template>
    <div id="app-spinner">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div
                        class="modal-container"
                        style="max-width: 25%; text-align: center"
                    >
                        <span id="spinner" class="fa fa-spinner"></span> &nbsp;
                        Loading...
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<style>
#spinner {
    -webkit-animation: rotation 1s linear infinite;
    -moz-animation: rotation 1s linear infinite;
    animation: rotation 1s linear infinite;
}

@-moz-keyframes spin {
    100% {
        -moz-transform: rotate(360deg);
    }
}
@-webkit-keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
    }
}
@keyframes spin {
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
<script>
export default {
    name: "app-spinner",
};
</script>



// WEBPACK FOOTER //
// Spinner.vue?9bfd0f18